import { render, staticRenderFns, recyclableRender, components } from "./publicLogo.vue?vue&type=template&id=708c0c3b&scoped=true&"
var renderjs
import script from "./publicLogo.vue?vue&type=script&lang=js&"
export * from "./publicLogo.vue?vue&type=script&lang=js&"
import style0 from "./publicLogo.vue?vue&type=style&index=0&id=708c0c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c0c3b",
  null,
  false,
  components,
  renderjs
)

export default component.exports